import * as classNames from "classnames";
import {
    IHighStateCount,
    ILifeChangingEvent,
} from "motw_core/Entity/ILifeChangingEvent";
import * as React from "react";
import { LifeChangingEventsRow } from "source/app/presentation/MainPanel/LifeChangingEvents/Row/LifeChangingEventsRow";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import { TRenderable } from "../../Shared/SharedTypes";
import { sharedStyles } from "../../Shared/Styles/SharedStyles";
import * as styles from "./LifeChangingEvents.css";
import { LCEChart } from "source/app/presentation/MainPanel/LifeChangingEvents/Chart/LCEChart";

class LifeChangingEvents extends React.Component<{}, ILCEState> {
    constructor(props: {}) {
        super(props);

        this.state = {
            data: [],
            highStateCounts: [],
        };
    }

    async componentDidMount() {
        const loadedData =
            await ClientDataProvider.GetRecordsAsync<ILifeChangingEvent>(
                `lifechangingevent`
            ) || [];

        const highStateCounts =
            await ClientDataProvider.GetRecordsAsync<IHighStateCount>(
                `rpc/highstatecounts`
            ) || [];

        const sortedData = loadedData.sort((a, b) => b.year - a.year);
        this.setState({ data: sortedData, highStateCounts });
    }

    render() {
        if (this.state.data.length === 0) {
            return null;
        }

        return (
            <div id="pnlLCE" className="collapse in marginBottom1em">
                <LCEChart data={this.state.data} />
                <div id="lifeChangeEventRows">
                    <div
                        className={classNames(
                            sharedStyles.table,
                            sharedStyles.marginTop1em,
                            [styles.LCETable]
                        )}
                    >
                        {this.state.data.map((row) => (
                            <LifeChangingEventsRow
                                row={row}
                                key={row.year}
                                highStateCounts={this.state.highStateCounts}
                            />
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default LifeChangingEvents;

export function LifeChangingEventCell({
    widthPct,
    withClass,
    children,
}: {
    widthPct: number;
    withClass?: string;
    children: TRenderable;
}) {
    return (
        <span
            style={{
                width: `${widthPct}%`,
                textAlign: `center`,
                margin: `5px`,
            }}
            className={withClass}
        >
            {children}
        </span>
    );
}

interface ILCEState {
    data: ILifeChangingEvent[];
    highStateCounts: IHighStateCount[];
}

